<template>
  <v-row id="heading-5" class="pb-15 secondary">
    <v-col cols="12" align="center" class="pt-15 px-5 px-md-0">
      <h1
        class="pt-15 primary--text title-font text-lg-h3 text-md-h3"
        data-aos="fade-down"
        data-aos-delay="1200"
        data-aos-duration="1500"
      >
        {{ $t("lblNuestrosProductos") }}
      </h1>
      <h4
        class="font-weight-medium support--text body-font pt-8 text-lg-h6 px-md-16"
        data-aos="fade-up"
        data-aos-delay="1500"
        data-aos-duration="1500"
      >
        {{ $t("lblConozcaNuestroProductos") }}
      </h4>
      <h5
        class="font-weight-regular support--text body-font pt-8 pb-16 text-body-1 px-8 px-md-16 mx-md-16"
        data-aos="fade-up"
        data-aos-delay="1700"
        data-aos-duration="1500"
      >
        {{ $t("lblResumenProductos") }}
      </h5>
    </v-col>
    <principal-preview v-for="item of items" :item="item" :key="item.id" />
  </v-row>
</template>

<script>
import PrincipalPreview from "@/components/proyects/PrincipalPreview";
import { mapState } from "vuex";

export default {
  name: "PreviewProyects",
  components: { PrincipalPreview },
  data: function () {
    return {};
  },
  computed: {
    ...mapState({
      items: (state) => state.projects.publicProjects,
      loading: (state) => state.projects.loading,
    }),
    firstProyect() {
      return this.items[0];
    },
    previewProyectItems() {
      return this.items.slice(1, 3);
    },
  },
  methods: {
    gotoProyectos() {
      this.$router.push({ name: "Productos" });
    },
  },
};
</script>
<style scoped src="@/assets/css/home.css"></style>
<style scoped></style>
